import { twMerge } from 'tailwind-merge';
import type { SegmentedSwitchProps } from './SegmentedSwitch.types';
import { SegmentedSwitchButton } from './SegmentedSwitchButton';

export const SegmentedSwitch = ({
  id,
  options,
  value,
  onChange,
  className,
  disabled,
  ...props
}: SegmentedSwitchProps) => {
  const wrapperClassName = twMerge(
    'flex rounded-[8px] p-[4px] border border-outline-primary-bw-03 bg-surface-primary-bw-02 w-full gap-[2px] h-[54px]',
    disabled && 'opacity-50 cursor-not-allowed',
    className
  );

  return (
    <div id={id} role='radiogroup' className={wrapperClassName} {...props}>
      {options.map((option) => {
        return (
          <SegmentedSwitchButton
            key={option.value}
            option={option}
            isSelected={value === option.value}
            parentDisabled={disabled}
            onClick={() => onChange(option.value)}
            {...option}
          />
        );
      })}
    </div>
  );
};
